import { CurrencyHelper } from "utils/helpers";

function useGetDividendProposal(dividendProposal?: number, maxAllowedDividend?: number) {
  const hasDividendProposal = dividendProposal !== undefined;

  let dividendProposalRounded = hasDividendProposal
    ? CurrencyHelper.toRoundedDownNearestThousand(dividendProposal)
    : undefined;
  const maxAllowedDividendRounded =
    maxAllowedDividend !== undefined ? CurrencyHelper.toRoundedDownNearestThousand(maxAllowedDividend) : undefined;
  if (
    dividendProposalRounded !== undefined &&
    maxAllowedDividendRounded !== undefined &&
    dividendProposalRounded > maxAllowedDividendRounded
  ) {
    dividendProposalRounded = maxAllowedDividendRounded;
  }

  return { hasDividendProposal, dividendProposalRounded };
}

export default useGetDividendProposal;
